interface CreateCaptureResponse {
  id: string;
  label: string | null;
  captureUrl: string;
  streamUrl: string;
  expiresAt: number;
}

export interface CaptureListEntry {
  id: string;
  label: string | null;
  requestCount: number;
  createdAt: number;
  expiresAt: number;
}

export async function createCapture(label?: string): Promise<CreateCaptureResponse> {
  const res = await fetch('/api/captures', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ label }),
  });
  if (!res.ok) throw new Error(`createCapture failed: ${res.status}`);
  return (await res.json()) as CreateCaptureResponse;
}

export async function listCaptures(): Promise<CaptureListEntry[]> {
  const res = await fetch('/api/captures', { credentials: 'include' });
  if (!res.ok) return [];
  const data = (await res.json()) as { captures: CaptureListEntry[] };
  return data.captures;
}

export async function deleteCapture(id: string): Promise<void> {
  await fetch(`/api/captures/${id}`, { method: 'DELETE', credentials: 'include' });
}
